import CoinTypeTab from "components/CoinTypeTab";
import DepositResult from "../Component/DepositResult";
import { Grid } from "@mui/material";
import MobileDepositHeader from "./Components/MobileDepositHeader";
import MobileDepositNetworks from "./Components/MobileDepositNetworks";
import MobileDepositSelectedCoin from "./Components/MobileDepositSelectedCoin";
import MobileDepositTypes from "./Components/MobileDepositTypes";
import PaymentGateway from "../Component/PaymentGateway";
import { TYPES } from "../constants";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

export function DepositMobile({
  coinList,
  selectedCoin,
  selectedCoinTypes,
  selectedCoinNetworks,
}) {
  const navigate = useNavigate();

  const { watch } = useFormContext();
  const coin = watch("coin");
  const type = watch("type");
  const network = watch("network");

  const selectedWallet = useMemo(
    () =>
      coinList?.lisWallet?.find(
        (wallet) =>
          wallet?.coinId === coin &&
          wallet?.typeId === type &&
          wallet?.networkId === network
      ),
    [type, coin, network, coinList?.lisWallet]
  );

  return (
    <Grid container>
      <MobileDepositHeader selectedCoin={selectedCoin} coinList={coinList} />

      <CoinTypeTab
        coinList={coinList}
        onChange={(data) => navigate(`/deposit/${data?.id}`)}
      />

      <MobileDepositSelectedCoin selectedCoin={selectedCoin} />

      <MobileDepositTypes selectedCoinTypes={selectedCoinTypes} />

      {type === TYPES.paymentGateway ? (
        <PaymentGateway selectedWallet={selectedWallet} />
      ) : (
        <>
          {selectedCoinNetworks?.length > 1 && (
            <MobileDepositNetworks
              selectedCoinNetworks={selectedCoinNetworks}
            />
          )}

          <DepositResult
            selectedWallet={selectedWallet}
            selectedCoin={selectedCoin}
          />
        </>
      )}
    </Grid>
  );
}
export default DepositMobile;
